import NODE_API from "./axios.helper";

export const getListToken = async () => {
    try {
        const res = (await NODE_API.get(`/token`))?.data;
        return res;
    } catch (error) {
        console.log(error);
    }
}